import React from 'react'
import { Button } from 'react-bootstrap'
import {
    PlusCircleFill,
    CheckCircleFill,
} from 'react-bootstrap-icons'

const IconButton = ({
    active,
    onClick = () => {}
}) => {
    const Icon = active ? CheckCircleFill : PlusCircleFill
    return (
        <div
            style={{
                position: 'absolute',
                top: '5px',
                right: '5px',
                zIndex: '5',
            }}
        >
            <Button
                variant='link'
                style={{ color: active ? 'white' : undefined }}
                onClick={onClick}
            >
                <Icon size={50} />
            </Button>
        </div>
    )
}

export default IconButton